import { cn } from "@lib/cn"
import { Loader2 } from "lucide-react"
import { useTranslation } from "react-i18next"

/**
 * Route-boundary spinner ONLY (PRD-60 chunk 0). Inside a page, a fetch
 * renders `<Skeleton>` / `<SkeletonRows>` so the layout holds its shape
 * instead of jumping from a centred spinner to a full page.
 */
export function PageLoader({ label, className }: { label?: string; className?: string }) {
  const { t } = useTranslation("common")
  return (
    <div
      className={cn("text-ink-subtle flex items-center justify-center gap-2 py-16", className)}
      role="status"
      aria-live="polite"
    >
      <Loader2 className="h-5 w-5 animate-spin" aria-hidden />
      <span className="text-sm">{label ?? t("state.loading")}</span>
    </div>
  )
}
